import React from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import {
  FiFacebook,
  FiInstagram,
  FiTwitter,
  FiGithub,
  FiYoutube,
  FiLinkedin,
  FaVimeo
} from "react-icons/fi"

const Footer = ({ logo, logoSecondary, footer, socials, general }) => {
  return (
    <footer
      className="footer bg-dark-grey text-white py-8"
      data-scroll-section
      data-scroll
    >
      <div className="container">
        <div className="footer__top grid lg:grid-cols-3 gap-8">
          <div className="footer__top-item grid gap-4">
            <div className="grid gap-2">
              {logo && (
                <Link to="/">
                  <GatsbyImage
                    className="w-[250px]"
                    objectFit="contain"
                    image={logo.asset.gatsbyImageData}
                    alt={logo.asset.altText}
                  />
                </Link>
              )}
              <p>{footer.siteInfoTagline}</p>
            </div>
          </div>
          <div className="footer__top-item grid gap-4">
            <h3 className="uppercase font-bold">{footer.primaryMenuTitle}</h3>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="underline-anim inline-block w-fit">Home</Link>

              {footer.primaryMenu.link.map((link, index) => {
                const internalLink = link._type === "linkInternal"
                const externalLink = link._type === "linkExternal"

                if (internalLink) {
                  const slug = link.page.slug.current

                  if (slug === "/home") {
                    return <Link to="/" className="underline-anim inline-block w-fit">{link.title}</Link>
                  } else {
                    return <Link to={slug} className="underline-anim inline-block w-fit">{link.title}</Link>
                  }
                } else {
                  return <Link to={link.url} className="underline-anim inline-block w-fit">{link.title}</Link>
                }
              })}
            </nav>
          </div>
          <div className="footer__top-item">
          <h3 className="uppercase font-bold mb-4">{socials.socialMenuTitle}</h3>
            <nav>
              <ul className="flex gap-8">
                {socials.social.map((link, index) => {
                  let iconRender

                  if (link.icon == "Facebook") {
                    iconRender = <FiFacebook />
                  }
                  if (link.icon == "Instagram") {
                    iconRender = <FiInstagram />
                  }
                  if (link.icon == "Linkedin") {
                    iconRender = <FiLinkedin />
                  }
                  if (link.icon == "Twitter") {
                    iconRender = <FiTwitter />
                  }
                  if (link.icon == "Youtube") {
                    iconRender = <FiYoutube />
                  }
                  if (link.icon == "Vimeo") {
                    iconRender = <FiVimeo />
                  }
                  return <Link to={link.url} target="_blank">{iconRender}</Link>
                })}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
